import React, { Fragment, useContext, useState } from 'react'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { Auth } from '../../../contexts/allContext'
import { useRequest } from '../../../hooks/useRequest'
import { svgs } from '../../../utils/findSvgs/findSvgs'
import { subscriptionsName, targetAudience, yesNoOptions } from '../../../utils/static/static'
import classes from './CreateSubscription.module.css'

export default function CreateSubscription() {
    const { stateAuth } = useContext(Auth)
    const token = stateAuth.token
    const { handleSubmit } = useRequest()
    const [form, setForm] = useState({
        name: '',
        description: '',
        target_audience: '',
        price_monthly: '',
        price_yearly: '',
        max_product_upload: '',
        max_feature_product: '',
        verified_badge: null,
        search_ranking: null,
        dedicated_support: null,
    })

    const [errors, setErrors] = useState({})

    const handleInput = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleSubmitForm = async () => {
        const newErrors = {}

        if (!form.name) newErrors.name = 'Name is required'
        if (!form.target_audience) newErrors.target_audience = 'Target audience is required'
        if (!form.price_monthly) newErrors.price_monthly = 'Price monthly is required'
        if (!form.price_yearly) newErrors.price_yearly = 'Price yearly is required'
        if (!form.max_product_upload) newErrors.max_product_upload = 'Max product upload is required'
        if (!form.max_feature_product) newErrors.max_feature_product = 'Max feature product is required'
        if (form.verified_badge === null) newErrors.verified_badge = 'Verified badge is required'
        if (form.search_ranking === null) newErrors.search_ranking = 'Search ranking is required'
        if (form.dedicated_support === null) newErrors.dedicated_support = 'Dedicated support is required'

        setErrors(newErrors)

        if (Object.keys(newErrors).length > 0) return

        const payload = {
            name: form.name,
            description: form.description,
            target_audience: form.target_audience,

            price_monthly: form.price_monthly,
            price_yearly: form.price_yearly,

            max_product_upload: form.max_product_upload,
            max_feature_product: form.max_feature_product,

            verified_badge: form.verified_badge,
            search_ranking: form.search_ranking,
            dedicated_support: form.dedicated_support,
        }

        try {
            const { data, isSuccess } = await handleSubmit(`v1/subscriptions/`, '', payload, token, 'POST')

            if (isSuccess) {
                toast.success('Subscription created successfully!')
                console.log('FINAL PAYLOAD:', data)

                setForm({
                    name: '',
                    description: '',
                    target_audience: '',
                    price_monthly: '',
                    price_yearly: '',
                    max_product_upload: '',
                    max_feature_product: '',
                    verified_badge: null,
                    search_ranking: null,
                    dedicated_support: null,
                })

                setErrors({})
            }
        } catch (error) {
            console.error('Failed to create subscription:', error)
            toast.error('Failed to create subscription')
        }
    }

    return (
        <Fragment>
            <div className={classes.title}>
                <h2>Create Subscription</h2>
            </div>

            <div className={classes.container}>
                <div className={classes.formLayout2}>
                    <div className={classes.formGroup}>
                        <label>
                            Subscription Plan Name <sup>*</sup>
                        </label>
                        <div className={`${classes.customDropDown} ${errors.name ? classes.error : ''}`}>
                            <Select
                                options={subscriptionsName}
                                placeholder="select subscrition plan"
                                classNamePrefix="react-select"
                                onChange={(e) => setForm({ ...form, name: e.value })}
                            />
                        </div>
                        {errors.name && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.name}
                            </p>
                        )}
                    </div>

                    <div className={classes.formGroup}>
                        <label htmlFor="audience" className={classes.label}>
                            Target Audience <sup>*</sup>
                        </label>
                        <div className={`${classes.customDropDown} ${errors.target_audience ? classes.error : ''}`}>
                            <Select
                                inputId="audience"
                                options={targetAudience}
                                placeholder="select target audience"
                                classNamePrefix="react-select"
                                onChange={(e) => setForm({ ...form, target_audience: e.value })}
                            />
                        </div>
                        {errors.target_audience && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.target_audience}
                            </p>
                        )}
                    </div>
                </div>

                <div className={classes.formGroup}>
                    <label>Description</label>
                    <textarea
                        name="description"
                        value={form.description}
                        onChange={handleInput}
                        placeholder="Write subscription description..."
                        style={{
                            border: '1px solid var(--border-color)',
                            borderRadius: '6px',
                            padding: '10px 20px',
                            fontSize: '14px',
                            minHeight: '120px',
                            outline: 'none',
                        }}
                    />
                </div>

                <div className={classes.formLayout2}>
                    <div className={classes.formGroup}>
                        <label>
                            Price (Monthly) <sup>*</sup>
                        </label>
                        <input
                            name="price_monthly"
                            placeholder="0"
                            type="number"
                            value={form.price_monthly}
                            onChange={handleInput}
                            className={errors.price_monthly ? classes.error : ''}
                        />
                        {errors.price_monthly && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.price_monthly}
                            </p>
                        )}
                    </div>

                    <div className={classes.formGroup}>
                        <label>
                            Price (Yearly) <sup>*</sup>
                        </label>
                        <input
                            name="price_yearly"
                            placeholder="0"
                            type="number"
                            value={form.price_yearly}
                            onChange={handleInput}
                            className={errors.price_yearly ? classes.error : ''}
                        />
                        {errors.price_yearly && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.price_yearly}
                            </p>
                        )}
                    </div>
                </div>

                <div className={classes.formLayout2}>
                    <div className={classes.formGroup}>
                        <label>
                            Max Product Upload <sup>*</sup>
                        </label>
                        <input
                            name="max_product_upload"
                            placeholder="0"
                            type="number"
                            value={form.max_product_upload}
                            onChange={handleInput}
                            className={errors.max_product_upload ? classes.error : ''}
                        />
                        {errors.max_product_upload && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.max_product_upload}
                            </p>
                        )}
                    </div>

                    <div className={classes.formGroup}>
                        <label>
                            Max Featured Product <sup>*</sup>
                        </label>
                        <input
                            name="max_feature_product"
                            placeholder="0"
                            type="number"
                            value={form.max_feature_product}
                            onChange={handleInput}
                            className={errors.max_feature_product ? classes.error : ''}
                        />
                        {errors.max_feature_product && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.max_feature_product}
                            </p>
                        )}
                    </div>
                </div>

                <div className={classes.formLayout}>
                    <div className={classes.formGroup}>
                        <label>
                            Verified Badge <sup>*</sup>
                        </label>
                        <div className={`${classes.customDropDown} ${errors.verified_badge ? classes.error : ''}`}>
                            <Select
                                options={yesNoOptions}
                                classNamePrefix="react-select"
                                placeholder="select verified badge"
                                onChange={(e) => setForm({ ...form, verified_badge: e.value })}
                            />
                        </div>
                        {errors.verified_badge && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.verified_badge}
                            </p>
                        )}
                    </div>

                    <div className={classes.formGroup}>
                        <label>
                            Search Ranking <sup>*</sup>
                        </label>
                        <div className={`${classes.customDropDown} ${errors.search_ranking ? classes.error : ''}`}>
                            <Select
                                options={yesNoOptions}
                                classNamePrefix="react-select"
                                placeholder="select search ranking"
                                onChange={(e) => setForm({ ...form, search_ranking: e.value })}
                            />
                        </div>
                        {errors.search_ranking && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.search_ranking}
                            </p>
                        )}
                    </div>

                    <div className={classes.formGroup}>
                        <label>
                            Dedicated Support <sup>*</sup>
                        </label>
                        <div className={`${classes.customDropDown} ${errors.dedicated_support ? classes.error : ''}`}>
                            <Select
                                options={yesNoOptions}
                                classNamePrefix="react-select"
                                placeholder="select dedicated support"
                                onChange={(e) => setForm({ ...form, dedicated_support: e.value })}
                            />
                        </div>
                        {errors.dedicated_support && (
                            <p className={classes.warning}>
                                {svgs.warning}
                                {errors.dedicated_support}
                            </p>
                        )}
                    </div>
                </div>

                <div className={classes.buttonContainer}>
                    <button type="button" onClick={handleSubmitForm}>
                        Submit
                    </button>
                </div>
            </div>
        </Fragment>
    )
}
